<script>
    import PopupConfirmed from '@/components/popups/PopupConfirmed.vue';
    import constants from '@/constants';

    export default {
        computed: {
            popupNames () {return constants.POPUPS_NAME},
            showPopupName() {return this.$store.getters.SHOP_POPUP_NAME},
        },
        components: {
            PopupConfirmed: PopupConfirmed,
        }
    }
</script>

<template>
    <div 
        v-if="showPopupName != null"
        class="popup_container"    
    >
        <PopupConfirmed 
            v-if="showPopupName === popupNames.CONFIRMED"
        />
    </div>
</template>